export default __webpack_public_path__ + "static/media/work_order.b84863c3.svg";